
import ContentPage from './ContentPage.js';
import './ContentPageWithBackButton.css';


export default function ContentPageWithBackButton({ backToLogin, subject, tK, topic, type, saveState, onBackButton, TopicsList = null, LoadContentPageForNextPrev = null, revisions=null, onRevisionsUpdate= null, searchstring = null}) {
    return (
        <div>
            {onBackButton && <button title="Go Back" className="GoBackArrow  w-[30px] z-[993] md:z-[992] h-[30px] right-[25px] top-[5px] md:top-[290px] md:w-[50px] md:h-[50px] md:left-[15px]" onClick={onBackButton}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" className="SearchBackArrow">
                <path d="M560-276 356-480l204-204 20 20-184 184 184 184-20 20Z"/>
                </svg>
            </button>}
            <ContentPage backToLogin={backToLogin} tK={tK} topic={topic} type={type} subject={subject} saveState={saveState} TopicsList={TopicsList} LoadContentPage={LoadContentPageForNextPrev} revisions={revisions} onRevisionsUpdate={onRevisionsUpdate} navigationParams={searchstring}/>
        </div>
    )
 }